import { create } from 'zustand';

export const useGameStore = create((set) => ({
	animation: null,

	switchAnimation: (payload = null) =>
		set({
			animation: payload,
		}),
}));
